import React from "react";
import StudentTableHW from "./StudentTableHW";


const StudentTablePropsHW = ({ studentinfo, basicinfo, setPendingPopup }) => {
  console.log("studentinfo", studentinfo)
  console.log("basicinfo", basicinfo)
  return (
    <>
      {studentinfo &&
        studentinfo.length > 0 &&
        studentinfo?.map((obj) => (
          <StudentTableHW
            Homework_id={`${obj.HomeWork_id}`}
            Student_id={`${obj.Student_id}`}
            avatar_profile={`${obj?.avatar_profile}`}
            gender={`${obj?.gender}`}
            profile_pic={`${obj.profile_pic}`}
            Name={`${obj.Name}`}
            School_Email={`${obj.School_Email}`}
            Class={`${obj.Class}`}
            Division={`${obj.Division}`}
            Submited_Date={`${obj.Submited_Date}`}
            Status={obj?.Status}
            basicinfo={basicinfo}
            obtained_marks={obj.obtained_marks}
            total_marks={obj.total_marks}
            setPendingPopup={setPendingPopup}
            Deadline={obj?.Deadline}
            deadlineDate={obj?.deadlineDate}
            submittedDate={obj?.submittedDate}
            subscription={obj?.subscription}
          />
        ))}
    </>
  );
};

export default StudentTablePropsHW;
